export default "__VITE_ASSET__heTkjinQ__"